import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { renderCSSString, getImgixUrl } from '../../../helpers';
import Link from '../../shared/Link/Link';
import './SponsorSpeakerDetails.scss';

export function SponsorSpeakerDetails(props) {
  const {
    spexSpeakers = [],
    pageConfig: { tenantId } = {},
    options: { data: { brand: { colours: { primary } = {} } = {} } = {} } = {},
  } = props;

  return (
    <ul>
      {spexSpeakers.map((speaker) => {
        return (
          <li key={speaker.id} className="organisation-speaker">
            <div className="organisation-speaker__photo">
              {speaker.photo && (
                <Link to={props.sitePath + '/speakers/' + speaker.uri}>
                  <img
                    data-src={getImgixUrl(tenantId, speaker.photo.path)}
                    alt={speaker.displayName}
                    className="lazy"
                  />
                </Link>
              )}
            </div>
            <div className="organisation-speaker__info">
              <Link to={props.sitePath + '/speakers/' + speaker.uri}>
                <span>{speaker.displayName}</span>
                <br />
                <span>{speaker.jobTitle}</span>
              </Link>
            </div>
          </li>
        );
      })}
      {renderCSSString(`
            .organisation-speaker {
              border-color: #${primary};
            }
        `)}
    </ul>
  );
}

SponsorSpeakerDetails.propTypes = {
  spexSpeakers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayName: PropTypes.string,
      jobTitle: PropTypes.string,
      photo: PropTypes.object,
      uri: PropTypes.string,
    }),
  ),
  sitePath: PropTypes.string,
  options: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    options: state.options,
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(SponsorSpeakerDetails);
